import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { LogoHorizontal } from '../components/Logo';
import { PasswordInput } from '../components/Input';
import { PrimaryButton } from '../components/Button';
import { FormHeader } from '../components/Card';
import api, { formatApiError } from '../lib/api';

export default function ResetPassword() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        if (password !== confirm) return setError('Las contraseñas no coinciden');
        if (password.length < 6) return setError('La contraseña debe tener al menos 6 caracteres');
        if (!token) return setError('Token inválido');
        setLoading(true);
        try {
            await api.post('/auth/reset-password', { token, password });
            alert('Contraseña restablecida. Inicia sesión.');
            navigate('/login', { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen bg-surface app-shell flex flex-col py-8 px-6">
            <div className="flex justify-center mb-6"><LogoHorizontal size="lg" /></div>
            <div className="bg-white rounded-[24px] shadow-card p-6 fade-up">
                <FormHeader title="Nueva contraseña" subtitle="Crea una nueva contraseña para acceder a tu cuenta." />

                <form onSubmit={submit} className="space-y-4">
                    <PasswordInput label="Contraseña" icon={Lock} placeholder="Tu nueva contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required testId="reset-password-input" />
                    <PasswordInput label="Confirmar contraseña" icon={Lock} placeholder="Repite tu contraseña" value={confirm} onChange={(e) => setConfirm(e.target.value)} required testId="reset-confirm-input" />

                    {error && <div className="text-red-500 text-sm font-medium" data-testid="reset-error">{error}</div>}

                    <PrimaryButton type="submit" loading={loading} testId="reset-submit-btn">Restablecer contraseña</PrimaryButton>
                </form>
            </div>
        </div>
    );
}
